module.exports = __webpack_public_path__ + "img/dia_internacional_da_mulher.8d29ce38.svg";